import { render, staticRenderFns } from "./NewVisitor.vue?vue&type=template&id=2dde61ab&scoped=true&"
import script from "./NewVisitor.vue?vue&type=script&lang=js&"
export * from "./NewVisitor.vue?vue&type=script&lang=js&"
import style0 from "./NewVisitor.vue?vue&type=style&index=0&id=2dde61ab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dde61ab",
  null
  
)

export default component.exports